module.exports = __webpack_public_path__ + "static/media/galerija_2013 (3).8dfa775c.jpg";